export const Required = 'This field is required'
export const Email = 'This field must be a valid Email Address'
export const Equals = 'This field must match '
